<!--
Locations > directions > room from screen
@author bmk11u
-->
<template>
  <div id="contain" class="container">
    <Nav name="Directions from Room" v-bind:home="true" v-if="authenticated" />
    <Nav name="Directions from Room" v-if="!authenticated" />

    <FuzzySearchList :authenticated="authenticated===true" :initialLocations="rooms" :fullLocations="rooms" :aliasLocations="[]"
      searchPlaceholder="Search for a room..." :buildingId="buildingId" :toId="toId" :toType="toType"/>

    <div id="pusher"></div>
    <Footer active="locations" v-if="authenticated"/>
  </div>
</template>

<script setup>
import Footer from '@/components/FooterMenu.vue'
import { useLocationsCommon } from '@/composables/LocationsCommon.js'
import { useRoute } from 'vue-router'
import FuzzySearchList from './FuzzySearchList.vue'
import { useMapCommon } from '../../composables/MapCommon'
import { ref, onMounted } from 'vue'

const { authenticated } = useLocationsCommon()
const { toLocation, urlToLocations } = useMapCommon()
const route = useRoute()

const buildingId = ref(null)
const toId = ref(null)
const toType = ref(null)
const buildingName = ref(null)
const rooms = ref(null)

onMounted( async () => {
  console.log('authenticated:', authenticated.value)

  buildingId.value = route.query.buildingId
  toId.value = route.query.toId
  toType.value = route.query.toType
  buildingName.value = route.query.buildingName

  rooms.value = await urlToLocations('/map/buildings/' + buildingId.value + '/rooms', room => toLocation(room.roomId, room.roomName))
  })
</script>
